"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAdditionalTextInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var models_1 = require("../../../models");
var CharacterLimitNote_1 = require("../CharacterLimitNote");
var ErrorMessage_1 = require("../ErrorMessage");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var StyledAdditionalText = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.5;\n  font-size: 16px;\n  color: ", ";\n  word-break: break-all;\n"], ["\n  line-height: 1.5;\n  font-size: 16px;\n  color: ", ";\n  word-break: break-all;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var needsAdditionalText = function (text) { return text != null && text != ''; };
var AdditionalText = function (_a) {
    var value = _a.value, color = _a.color, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(StyledAdditionalText, { className: className, color: color, dangerouslySetInnerHTML: {
            __html: value,
        } }));
};
var AdditionalTextInputWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  ", ";\n  display: inline-block;\n  min-width: 90px;\n  vertical-align: middle;\n\n  label: InputWrapper;\n"], ["\n  max-width: 100%;\n  ", ";\n  display: inline-block;\n  min-width: 90px;\n  vertical-align: middle;\n\n  label: InputWrapper;\n"])), function (_a) {
    var width = _a.width, widthUnit = _a.widthUnit;
    return width && "width ".concat(width).concat(widthUnit);
});
var widthUnit = 'px';
var TextAdditionalTextInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, before = _a.before, after = _a.after, onChange = _a.onChange, onBlur = _a.onBlur, text = _a.text, errorMessages = _a.errorMessages, disabled = _a.disabled, design = _a.design, width = _a.width, className = _a.className, maxLength = _a.maxLength, minLength = _a.minLength, displayError = _a.displayError;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    var displayLimitNote = maxLength != null || minLength != null;
    var _b = design.colors, inputFont = _b.inputFont, noticeAndGuideFont = _b.noticeAndGuideFont;
    return ((0, jsx_runtime_1.jsxs)(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.text, inputFormatType: models_1.TEXT_PROPERTY_INPUT_TYPE.additionalText, errorMessages: errorMessages, className: className, displayError: displayError }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [needsAdditionalText(before) && ((0, jsx_runtime_1.jsx)(AdditionalText, { css: { marginRight: '8px', label: 'TextAdditionalTextBeforeInput' }, value: before, color: inputFont })), (0, jsx_runtime_1.jsx)(AdditionalTextInputWrapper, __assign({ width: width, widthUnit: widthUnit }, { children: (0, jsx_runtime_1.jsx)(Input_1.Input, { "data-cy-property-item": true, error: displayError, value: text, type: "text", placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, name: propertyId, id: propertyId, "aria-invalid": displayError, "aria-errormessage": (0, ErrorMessage_1.getFieldErrorMessageId)(propertyId) }) })), needsAdditionalText(after) && ((0, jsx_runtime_1.jsx)(AdditionalText, { css: { marginLeft: '8px', label: 'TextAdditionalTextAfterInput' }, value: after, color: inputFont }))] }), displayLimitNote && ((0, jsx_runtime_1.jsx)(CharacterLimitNote_1.CharacterLimitNote, { css: { marginTop: '4px' }, color: noticeAndGuideFont, maxLength: maxLength, minLength: minLength, value: text }))] })));
};
exports.TextAdditionalTextInput = TextAdditionalTextInput;
var templateObject_1, templateObject_2;
